<div class="tds-container-fluid">
    <div class="tds-row">
        <h2 class="tds-headline-02">Programa BNDES</h2>
    </div>


    <tds-accordion>
        <!-- Filtros -->
        <tds-accordion-item header="Filtros" aria-level="6" expanded>
            <div class="tds-row">
                <tds-text-field type="text" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Título" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px; width: 29%;"></tds-text-field>
                <tds-text-field type="date" helper="De *" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="De" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;  width: 15%;"></tds-text-field>
                <tds-text-field type="date" helper="Até *" size="lg" state="default" label="Label" label-position="no label" no-min-width placeholder="Até" tds-aria-label="A text field component" required="false" autocomplete="off" style="padding-right: 45px;  width: 15%;"></tds-text-field>
            </div>
            <div class="tds-row" style="padding-top: 20px; justify-content: center">
                <tds-button type="button" variant="primary" size="lg" text="Pesquisar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
                <tds-button type="button" variant="secondary" size="lg" text="Limpar" animation="none" tds-aria-label="undefined" name="" value="" style="padding-right: 5px;"></tds-button>
            </div>            
        </tds-accordion-item>

        <!-- Tabela -->
        <tds-accordion-item header="Tabela" aria-level="6" expanded>
            <div class="tds-row">
                <tds-table vertical-dividers="false" compact-design="false" responsive="true" no-min-width>
                    <tds-table-toolbar>
                        <div slot="end" class="tds-u-flex tds-u-align-items-center tds-u-h-100 tds-u-gap1" style="margin-left: 8px;">
                            <tds-button variant="secondary" size="sm" title="Inserir">
                                <tds-icon slot="icon" class="tds-btn-icon" size="18px" name="plus"></tds-icon>
                            </tds-button>
                        </div>
                    </tds-table-toolbar>
                    <tds-table-header>
                        <tds-header-cell cell-key="actions"></tds-header-cell>
                        <tds-header-cell cell-key='coD_ORIGINAL' cell-value='Id' sortable></tds-header-cell>
                        <tds-header-cell cell-key='titulo' cell-value='Título' sortable></tds-header-cell>
                        <tds-header-cell cell-key='descricao' cell-value='Descrição' sortable></tds-header-cell>
                        <tds-header-cell cell-key='dataIni' cell-value='Data Início' sortable></tds-header-cell>
                        <tds-header-cell cell-key='dataFim' cell-value='Data Fim' sortable></tds-header-cell>
                    </tds-table-header>
                    <tds-table-body>
                        <tds-table-body-row>
                            <tds-body-cell cell-key="actions">
                                <div class="action-buttons" title="Excluir">
                                    <tds-icon id="edit" name="cross" size="20px" style="cursor: pointer;" ></tds-icon>
                                </div>
                            </tds-body-cell>
                            <tds-body-cell cell-key="coD_ORIGINAL">12344</tds-body-cell>
                            <tds-body-cell cell-key="titulo">PROCAMINHONEIRO</tds-body-cell>
                            <tds-body-cell cell-key="descricao"></tds-body-cell>
                            <tds-body-cell cell-key="dataIni">13/03/2012</tds-body-cell>
                            <tds-body-cell cell-key="dataFim">31/12/2012</tds-body-cell>
                        </tds-table-body-row>
                    </tds-table-body>
                </tds-table>
            </div>
        </tds-accordion-item>
    </tds-accordion>
</div>